// extracted by css-extract-rspack-plugin
export default {"container":"PSH4YM1xswU2pnGP","frame":"W1UOFxgk6gFfLwKe"};